import { CanvasData, Point, ImageData, Config } from "@/types";

export const getPoints = (
    canvasData: CanvasData,
    imageData: ImageData,
    config: Config
) => {
    const points: Point[] = [];
    const range =
        Math.round(((100 - config.resolution) / 200) * canvasData.size.width) +
        1;
    for (let i = 0; i < config.n; i++) {
        const x = Math.round(Math.random() * canvasData.size.width);
        const y = Math.round(Math.random() * canvasData.size.height);

        if (isNear(imageData, canvasData, x, y, range)) {
            const point: Point = {
                x,
                y,
            };
            points.push(point);
        }
    }
    return points;
};

const isNear = (
    imageData: ImageData,
    canvasData: CanvasData,
    x: number,
    y: number,
    range: number
) => {
    let startX = x - range;
    let startY = y - range;
    let endX = x + range;
    let endY = y + range;
    if (startX < 0) {
        startX = 0;
    }
    if (startY < 0) {
        startY = 0;
    }

    if (endX > canvasData.size.width) {
        endX = canvasData.size.width;
    }
    if (endY > canvasData.size.height) {
        endY = canvasData.size.height;
    }
    for (let cy = startY; cy < endY; cy++) {
        for (let cx = startX; cx < endX; cx++) {
            const pixel = cy * canvasData.size.width + cx;
            if (isDarkPixel(imageData, pixel)) {
                return true;
            }
        }
    }
    return false;
};

const isDarkPixel = (imageData: ImageData, pixel: number) => {
    const position = pixel * 4;
    const r = imageData[position];
    const g = imageData[position + 1];
    const b = imageData[position + 2];
    const colorValue = r + g + b;
    return colorValue < 382;
};
